import React from 'react'
import {NavLink} from 'react-router-dom'
import {MealsIcon, ChartIcon, LeafIcon, SlidersIcon} from './Icons'

const tabs = [
  {to: '/', label: 'Today', Icon: MealsIcon, exact: true},
  {to: '/history', label: 'History', Icon: ChartIcon},
  {to: '/foods', label: 'Foods', Icon: LeafIcon},
  {to: '/settings', label: 'Settings', Icon: SlidersIcon},
]

export default function Nav() {
  return (
    <nav className="tabbar">
      {tabs.map(t => (
        <NavLink key={t.to} to={t.to} exact={t.exact} className="tab" activeClassName="tab-active">
          <span className="tab-icon">
            <t.Icon />
          </span>
          <span className="tab-label">{t.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
